import { fetchAllBids } from '../../ducks/bids.duck';

export const loadData = () => dispatch => {
  return dispatch(fetchAllBids());
};
